import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import InventoryHeader from './InventoryHeader';
import { withRouter } from 'react-router-dom';
import Loading from '../Loading';
import {Table} from "react-bootstrap";
import { getStockStatusLabel } from './stockStatus';

const base = 'inventory-adjustment';

const formatUnavailableComboOptionNames = (unavailableComboOptionNames) => {
    if (!unavailableComboOptionNames) {
        return '';
    }

    if (Array.isArray(unavailableComboOptionNames)) {
        return unavailableComboOptionNames
            .filter(Boolean)
            .join(', ');
    }

    return unavailableComboOptionNames;
};

const matchesSearch = (item, category, searchQuery) => {
    const normalizedSearch = searchQuery.trim().toLowerCase();

    if (!normalizedSearch) {
        return true;
    }

    const componentMatches = (item.component_inventories || []).some((componentInventory) => [
        componentInventory.unit_sku,
        componentInventory.name,
    ]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(normalizedSearch)));

    return componentMatches || [
        item.sku,
        item.name,
        item.category,
        category,
        formatUnavailableComboOptionNames(item.unavailable_combo_option_names),
    ]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(normalizedSearch));
};


@inject('ComponentStockStore', 'UserStore')
@observer
class LiveInventoryComponent extends Component {
    state = {
        searchQuery: '',
    };

    componentDidMount = () => {
        const {
            ComponentStockStore: {
                getStockCountAvailability,
            },
            UserStore: {
                position
            }
        } = this.props;

        document.body.classList.add('current-stock-dashboard-scroll');
        if (position == 'Territory Manager') {
            this.refreshData();
        } else {
            getStockCountAvailability(this.hideLoader, this.refreshData);
        }
        const SIXTY_SECONDS = 1000 * 60;
        this.interval = setInterval(() => {
            if (position == 'Territory Manager') {
                this.refreshData();
            } else {
                getStockCountAvailability(this.hideLoader, this.refreshData);
            }
        }, SIXTY_SECONDS);
    };

    refreshData = () => {
        const {
            ComponentStockStore: {
                handleGetLiveInventoryOverview,
            },
        } = this.props;
        handleGetLiveInventoryOverview();
    };

    hideLoader = () => {
        const {
            ComponentStockStore
        } = this.props;
        ComponentStockStore.inventoryOverviewLoading = false;
    }

    componentWillUnmount() {
        document.body.classList.remove('current-stock-dashboard-scroll');
        clearInterval(this.interval);
    }

    render() {
        const {
            ComponentStockStore: { inventoryOverviewLoading, skusByCategoryForLiveInventoryComponent },
        } = this.props;
        const { searchQuery } = this.state;
        if (inventoryOverviewLoading) {
            return <Loading />;
        }
        let rows = [];
        const INVENTORY_THRESHOLD = 3;
        const normalizedSearch = searchQuery.trim();

        if (skusByCategoryForLiveInventoryComponent) {
            for (const category of Object.keys(skusByCategoryForLiveInventoryComponent)) {
                const items = (skusByCategoryForLiveInventoryComponent[category] || [])
                    .filter((item) => matchesSearch(item, category, normalizedSearch));

                if (items.length === 0) {
                    continue;
                }

                rows.push(
                    <tr style={{backgroundColor: "rgb(246, 185, 78)", textAlign: "left"}}>
                        <td colSpan="44">
                            <h3>{category}</h3>
                        </td>
                    </tr>
                )

                for (const item of items) {
                    const unavailableComboOptionNames = formatUnavailableComboOptionNames(item.unavailable_combo_option_names);
                    let columns = [];
                    for (var i = 0; i < 10; i++) {
                        columns.push(
                            <td style={{borderLeft: "3px solid gray"}}
                            >
                                {item.component_inventories.length > i ? (item.component_inventories[i].unit_sku + (item.component_inventories[i].mandatory ? '': ' (optional)'))
                                    : '-'}
                            </td>
                        )
                        columns.push(
                            <td style={{fontSize: 'x-small'}}>
                                {item.component_inventories.length > i ? item.component_inventories[i].name : '-'}
                            </td>
                        )
                        columns.push(
                            <td className={item.component_inventories.length > i
                            && item.component_inventories[i].quantity - item.component_inventories[i].pre_orders < INVENTORY_THRESHOLD
                            && item.component_inventories[i].mandatory ? 'bg--red--important': null}
                            >
                                {item.component_inventories.length > i ? getStockStatusLabel(item.component_inventories[i].quantity) : '-'}
                            </td>
                        )
                        columns.push(
                            <td  className={item.component_inventories.length > i
                            && item.component_inventories[i].pre_orders >= INVENTORY_THRESHOLD
                            && item.component_inventories[i].quantity - item.component_inventories[i].pre_orders < INVENTORY_THRESHOLD
                            && item.component_inventories[i].mandatory ? 'bg--red--important': null}
                            >
                                {item.component_inventories.length > i ? item.component_inventories[i].pre_orders : '-'}
                            </td>
                        )
                    }
                    rows.push(
                            <tr>
                                <td
                                >
                                    {item.sku}
                                </td>
                                <td
                                >
                                    <div>{item.name}</div>
                                    {unavailableComboOptionNames &&
                                        <div style={{fontSize: 'x-small', color: '#d9534f', marginTop: '4px'}}>
                                            Unavailable combo options: {unavailableComboOptionNames}
                                        </div>
                                    }
                                </td>
                                <td className={item.quantity < INVENTORY_THRESHOLD ? 'bg--red--important': null}
                                >
                                    {getStockStatusLabel(item.quantity)}
                                </td>
                                <td
                                >
                                    {item.pre_orders}
                                </td>
                                {columns}
                            </tr>
                        )
                }
            }
        }
        return (
            <Fragment>
                <div className="current-stock-dashboard-page">
                    <InventoryHeader title='Current Stock Dashboard (Component)' />
                    <div className="inventory-dashboard-search">
                        <input
                            className="inventory-dashboard-search__input"
                            type="search"
                            value={searchQuery}
                            onChange={(event) => this.setState({ searchQuery: event.target.value })}
                            placeholder="Search menu item, component SKU or name"
                        />
                    </div>
                    <div className="current-stock-dashboard current-stock-dashboard--component">
                        {rows.length > 0 ? (
                            <Table striped bordered className="fs--medium current-stock-dashboard__component-table">
                        <thead>
                            <tr>
                                <th>
                                    {`SKU`}
                                </th>
                                <th>
                                    Menu Item Full Name
                                </th>
                                <th>
                                    In Stock
                                </th>
                                <th>
                                    Pre-orders
                                </th>
                                <th>
                                    Component 1
                                </th>
                                <th>
                                    Name
                                </th>
                                <th>
                                    In Stock
                                </th>
                                <th>
                                    Pre-orders
                                </th>
                                <th>
                                    Component 2
                                </th>
                                <th>
                                    Name
                                </th>
                                <th>
                                    In Stock
                                </th>
                                <th>
                                    Pre-orders
                                </th>
                                <th>
                                    Component 3
                                </th>
                                <th>
                                    Name
                                </th>
                                <th>
                                    In Stock
                                </th>
                                <th>
                                    Pre-orders
                                </th>
                                <th>
                                    Component 4
                                </th>
                                <th>
                                    Name
                                </th>
                                <th>
                                    In Stock
                                </th>
                                <th>
                                    Pre-orders
                                </th>
                                <th>
                                    Component 5
                                </th>
                                <th>
                                    Name
                                </th>
                                <th>
                                    In Stock
                                </th>
                                <th>
                                    Pre-orders
                                </th>
                                <th>
                                    Component 6
                                </th>
                                <th>
                                    Name
                                </th>
                                <th>
                                    In Stock
                                </th>
                                <th>
                                    Pre-orders
                                </th>
                                <th>
                                    Component 7
                                </th>
                                <th>
                                    Name
                                </th>
                                <th>
                                    In Stock
                                </th>
                                <th>
                                    Pre-orders
                                </th>
                                <th>
                                    Component 8
                                </th>
                                <th>
                                    Name
                                </th>
                                <th>
                                    In Stock
                                </th>
                                <th>
                                    Pre-orders
                                </th>
                                <th>
                                    Component 9
                                </th>
                                <th>
                                    Name
                                </th>
                                <th>
                                    In Stock
                                </th>
                                <th>
                                    Pre-orders
                                </th>
                                <th>
                                    Component 10
                                </th>
                                <th>
                                    Name
                                </th>
                                <th>
                                    In Stock
                                </th>
                                <th>
                                    Pre-orders
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows}
                        </tbody>
                        </Table>
                        ) : normalizedSearch ? (
                            <div className="inventory-dashboard-search__empty">No matching components or items found.</div>
                        ) : (
                            null
                        )}
                    </div>
                </div>
                {rows.length == 0 && !normalizedSearch &&
                    <div className='ml'>This screen is disabled. This will be re-enabled before opening hours tomorrow</div>
                }
            </Fragment>
        );
    }
}   

export default withRouter(LiveInventoryComponent);
